import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./page/Home";
import Parcours from "./page/Parcours";
import Projet from "./page/Projet";
import Contacte from "./page/Contacte";
import { ToastProvider } from "react-toast-notifications";
function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/parcours" element={<Parcours />} />
          <Route path="/projet" element={<Projet />} />
          <Route path="/Contacte" element={<Contacte />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
